'use client'

import { useState } from 'react'

import { Topbar } from "@/components/custom/header/topbar";
import { Section } from "@/components/ui/section";
import { MainMenu } from '@/components/custom/header/mainmenu/mainMenu'
import {MainMenuItemModel} from "@/components/custom/header/mainmenu/mainMenuItem";
import {LangCountrySelector} from "@/components/custom/header/mainmenu/langCountrySelector";
import {HeaderSearchBar} from "@/components/custom/header/headerSearchBar";

interface HeaderComponentProps {
    locale: string,
    navAccountTranslation: {
        label: string;
        tooltip: string;
    },
    navBookmarksTranslation: {
        label: string;
        tooltip: string;
    },
    navLanguageTranslation: {
        tooltip: string;
    },
    unitSystemSwitchTranslation: {
        heading: string;
        metric: string;
        imperial: string;
        notification: string;
    },
    scopeSystemSwitchTranslation: {
        heading: string;
        internal: string;
        external: string;
    },
    langSelectorHeadline: string,
    searchLabels: {
        search: string;
        noResults: string;
    },
    mainMenuData: MainMenuItemModel[],
    env: string,
    entraIdIssuer: string
}

export function HeaderComponent({ locale, navAccountTranslation, navBookmarksTranslation, unitSystemSwitchTranslation, langSelectorHeadline, navLanguageTranslation, searchLabels, mainMenuData, scopeSystemSwitchTranslation, env, entraIdIssuer }: HeaderComponentProps) {
    const [ language, region ] = locale.split('-');
    const [langSelectorOpen, setLangSelectorOpen] = useState(false);

    return (
        <header className='header'>
            <div className='header__wrapper'>
                <Topbar
                    langSelectorOpen={langSelectorOpen}
                    setLangSelectorOpen={setLangSelectorOpen}
                    navAccountTranslation={navAccountTranslation}
                    navBookmarksTranslation={navBookmarksTranslation}
                    navLanguageTranslation={navLanguageTranslation}
                    locale={locale}
                    env={env}
                    entraIdIssuer={entraIdIssuer}
                />
                <LangCountrySelector
                    langSelectorHeadline={langSelectorHeadline}
                    langSelectorOpen={langSelectorOpen}
                    setLangSelectorOpen={setLangSelectorOpen}
                    unitSystemSwitchTranslation={unitSystemSwitchTranslation}
                    scopeSystemSwitchTranslation={scopeSystemSwitchTranslation}
                    language={language}
                    region={region}
                />
                <Section id='mainmenu' name='mainmenu' sectionClassName='header__section relative' padding={'none'} className="">
                    <MainMenu menuItems={mainMenuData} locale={locale} />
                    <HeaderSearchBar locale={locale} searchLabels={searchLabels} />
                </Section>
            </div>
        </header>
    )
}